const ApnaLogo = ({ size = "50" }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 50 50"
	>
		<g fill="none" fillRule="evenodd">
			<g>
				<g>
					<path
						fill="#FFF"
						stroke="#EDEBED"
						d="M9.625 0h28.75C43.691 0 48 4.31 48 9.625v28.75C48 43.691 43.69 48 38.375 48H9.625C4.309 48 0 43.69 0 38.375V9.625C0 4.309 4.31 0 9.625 0z"
						transform="translate(-11 -583) translate(12 584)"
					/>
					<path
						fill="#FFD166"
						d="M38.375 48H32v-6l15.294.001C45.862 45.52 42.408 48 38.375 48z"
						transform="translate(-11 -583) translate(12 584)"
					/>
					<path
						fill="#2BB793"
						d="M16 42v6H9.625c-4.033 0-7.487-2.48-8.919-5.999L16 42z"
						transform="translate(-11 -583) translate(12 584)"
					/>
					<path
						fill="#83BDE4"
						d="M16 42H32V48H16z"
						transform="translate(-11 -583) translate(12 584)"
					/>
					<path
						fill="#4D3951"
						fillRule="nonzero"
						d="M13.143 25.937c0 .324.04.564.121.72.08.156.225.274.433.355l-.693 2.201c-.624-.046-1.132-.164-1.525-.355-.393-.19-.717-.5-.971-.927-.6.901-1.531 1.352-2.79 1.352-.914 0-1.65-.275-2.21-.824-.561-.549-.841-1.256-.841-2.123 0-1.028.381-1.814 1.144-2.357.762-.543 1.872-.815 3.328-.815h.658v-.225c0-.463-.092-.775-.277-.936-.185-.162-.537-.243-1.057-.243-.278 0-.633.043-1.066.13-.434.087-.876.205-1.326.355l-.746-2.184c.567-.23 1.182-.41 1.846-.537.665-.127 1.269-.19 1.812-.19 1.456 0 2.513.28 3.172.84.658.56.988 1.418.988 2.574v3.19zm-4.368.936c.208 0 .401-.052.58-.156.18-.104.327-.237.442-.398v-1.37h-.364c-.485 0-.843.087-1.074.26-.231.174-.347.44-.347.798 0 .265.07.476.208.632.139.156.324.234.555.234zm11.717-7.54c1.144 0 2.008.434 2.591 1.3.584.867.876 2.08.876 3.64 0 .96-.153 1.817-.46 2.574-.306.757-.74 1.352-1.3 1.786-.56.433-1.204.65-1.932.65-.879 0-1.595-.307-2.15-.919v4.16l-3.432.347V19.68h3.051l.139.901c.37-.439.783-.757 1.239-.953.456-.196.916-.295 1.378-.295zM19.14 26.84c.867 0 1.3-.838 1.3-2.514 0-.705-.046-1.242-.139-1.612-.092-.37-.216-.615-.372-.736-.156-.122-.356-.182-.598-.182-.486 0-.89.289-1.214.866v3.536c.15.231.307.396.468.494.162.099.347.148.555.148zm11.977-7.506c.775 0 1.384.243 1.829.728.445.486.667 1.167.667 2.046v6.829h-3.432v-6.205c0-.347-.043-.584-.13-.711-.086-.127-.216-.19-.39-.19-.381 0-.768.306-1.161.918v6.188h-3.432V19.68h2.999l.242.953c.428-.45.864-.78 1.309-.988.445-.208.945-.312 1.5-.312zm11.874 6.604c0 .324.04.564.121.72.08.156.225.274.433.355l-.693 2.201c-.624-.046-1.132-.164-1.525-.355-.393-.19-.717-.5-.971-.927-.6.901-1.531 1.352-2.79 1.352-.914 0-1.65-.275-2.21-.824-.561-.549-.841-1.256-.841-2.123 0-1.028.381-1.814 1.144-2.357.762-.543 1.872-.815 3.328-.815h.658v-.225c0-.463-.092-.775-.277-.936-.185-.162-.537-.243-1.057-.243-.278 0-.633.043-1.066.13-.434.087-.876.205-1.326.355l-.746-2.184c.567-.23 1.182-.41 1.846-.537.665-.127 1.269-.19 1.812-.19 1.456 0 2.513.28 3.172.84.658.56.988 1.418.988 2.574v3.19zm-4.368.936c.208 0 .401-.052.58-.156.18-.104.327-.237.442-.398v-1.37h-.364c-.485 0-.843.087-1.074.26-.231.174-.347.44-.347.798 0 .265.07.476.208.632.139.156.324.234.555.234z"
						transform="translate(-11 -583) translate(12 584)"
					/>
				</g>
			</g>
		</g>
	</svg>
);

export default ApnaLogo;
